import { businessKey } from 'queryKeys';

import { TYPE_POSTBACK, TYPE_CONVERSION } from 'scenes/Integrations/constants';

export const INTEGRATIONS = 'integrations';
export const CONVERSION = 'conversion';
export const POSTBACK = 'postback';

const MUTATION_START = 'start';
const MUTATION_STOP = 'stop';
const MUTATION_EXPORT = 'exportInt';

const queryIntegrations = businessKey.query(INTEGRATIONS);
const queryConversion = queryIntegrations.query(CONVERSION);
const queryPostback = queryIntegrations.query(POSTBACK);

export const grids = queryIntegrations.grids();
export const grid = queryIntegrations.grid();

export const mutations = queryIntegrations.mutations();
export const start = mutations.mutate(MUTATION_START);
export const stop = mutations.mutate(MUTATION_STOP);
export const exportInt = mutations.mutate(MUTATION_EXPORT);

export const remove = mutations.delete();

export const detailsConversion = queryConversion.details();
export const modelConversion = queryConversion.exact();

export const mutationsConversion = queryConversion.mutations();
export const createConversion = mutationsConversion.create();
export const updateConversion = mutationsConversion.update();

export const detailsPostback = queryPostback.details();
export const modelPostback = queryPostback.exact();

export const mutationsPostback = queryPostback.mutations();
export const createPostback = mutationsPostback.create();
export const updatePostback = mutationsPostback.update();

export const getDetailsByType = (type) => {
  if (type === TYPE_POSTBACK) {
    return detailsPostback;
  }

  if (type === TYPE_CONVERSION) {
    return detailsConversion;
  }

  return null;
};
